export enum AddToBasketModal {
  Basic = 'basic_modal',
  MembershipOffer = 'modal_with_membership_offer',
  NAME = 'add_to_basket_modal',
  None = 'no_modal',
}
